import {format, parse, parseISO} from 'date-fns'
import i18next from 'i18next'
import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {getChatOrder, postChatOrder} from 'src/api/modules/order'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {notificationSelector, setNotification} from 'src/redux/slices/notificationSlices'
import swal from 'sweetalert'

export const useChatOrderModal = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {notification} = useAppSelector(notificationSelector)

  const [openModal, setOpenModal] = useState(false)
  const [fullChat, setFullChat] = useState<any>([])
  const [comment, setComment] = useState('')
  const [_isLoading, setIsLoading] = useState(false)

  const isOrderSubHeader = notification?.type === 'order_sub_header'
  const isOrderSubmission = notification?.type === 'order_submission'

  /**
   * Handler untuk menutup ChatOrderModal
   */
  const handleCloseModal = () => {
    setOpenModal(false)
    dispatch(setNotification(null))
  }

  /**
   * Handler untuk mengambil data chat berdasarkan:
   * - id: parent_id | child_id
   * - type: 'order_submission' | 'order_sub_header'
   */
  const handleGetChat = async () => {
    if (!notification) return

    const {parent_id, child_id, type: flag} = notification

    if (flag !== 'order_sub_header' && flag !== 'order_submission') return

    setIsLoading(true)

    const id = !isOrderSubmission ? Number(parent_id) : Number(child_id)

    return getChatOrder(id, flag)
      .then((res: any) => {
        const {read_only} = notification
        setFullChat(res.data.data)
        setOpenModal(read_only ? false : true)
      })
      .finally(() => setIsLoading(false))
  }

  /**
   * Handler untuk menambahkan chat berdasarkan:
   * - id: parent_id | child_id
   * - type: 'order_submission' | 'order_sub_header'
   */
  const handlePostChat = async () => {
    if (!notification) return

    const {parent_id, child_id, type: flag} = notification

    if (flag !== 'order_sub_header' && flag !== 'order_submission') return

    const user_id = localStorage.getItem('user-id')
    const credentials = localStorage.getItem('credential')
    const id = !isOrderSubmission ? Number(parent_id) : Number(child_id)

    setIsLoading(true)

    return postChatOrder(i18next.language, {parent_id: id, user_id, comment, credentials}, flag)
      .then((res) => {
        swal({
          title: `${t('Komentar Berhasil Ditambahkan')}`,
          icon: 'success',
        }).then(() => {
          handleGetChat()
          setComment('')
          const areacomment = document.getElementById('areachat') as HTMLInputElement
          if (areacomment != null) areacomment.value = ''
        })
      })
      .catch((error) => {
        swal({title: t(error.response.data.message), icon: 'error'})
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  /**
   * Function untuk mengambil waktu berdasarkan data
   * @param data
   * @returns
   */
  const getTime = (data: any) => {
    try{
      const parsedDate = parseISO(data)
      const formattedTime = format(parsedDate, 'dd MMM yyyy, HH:mm')
      return formattedTime
    }catch(e: any){
      return '-'
    }
  }

  /**
   * Fetch chat data while notification change
   */
  useEffect(() => {
    handleGetChat()
  }, [notification])

  /**
   * Reset the notification state while unmounted the component
   */
  useEffect(() => {
    return () => {
      dispatch(setNotification(null))
    }
  }, [])

  return {
    openModal,
    notification,
    fullChat,
    setComment,
    getTime,
    handleCloseModal,
    handlePostChat,
  }
}
